import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const TEMPLATE = {
    GET_LIST: createActionTypes("GET_LISTA_TEMPLATE"),
    GET_TEMPLATE: createActionTypes("GET_TEMPLATE"),
    SAVE_TEMPLATE: createActionTypes("SAVE_TEMPLATE"),

    GET_TEMPLATE_HISTORY: createActionTypes("GET_TEMPLATE_HISTORY"),
    GET_TEMPLATE_HISTORY_LIST: createActionTypes("GET_TEMPLATE_HISTORY_LIST"),
    GET_TEMPLATE_ALL: createActionTypes("GET_TEMPLATE_ALL"),
    
    LOAD_EMPTY: "LOAD_EMPTY_TEMPLATE",
    CLEAN_MESSAGE: "CLEAN_MESSAGE_TEMPLATE",
    CHANGE_PAGE_SIZE_TEMPLATE: "CHANGE_PAGE_SIZE_TEMPLATE"
}